
angular.module('mtic.components.login')
.component('mticFinalizationAccountRegistration', {

  templateUrl: 'template.html',

  bindings: {
    flow: '=',
    info: '=',
    profile: '='
  },

  controllerAs: 'reg',

  controller(
    $scope, 
    $log, 
    $timeout, 
    TIMING_CONSTANTS,
    language, 
    EventManager, 
    api, 
    IAMManager, 
    userAccount, 
    IAM_CODES, 
    LOGIN_CONSTANTS
  ) {

    // self
    var reg = this;
    
    // event manager
    var eventManager = new EventManager('mticFinalizationAccountRegistration', $scope);

    // constants

    // model
    $scope.language = language;
    var msfUser = reg.profile || {};
    var msfEmail = msfUser.unique_name;

    // utils
    var isEmptyString = function(str){
      return !str || str.replace(/\ /g,'').length === 0 || str === null || str === undefined
    };

    var isValidCode = function (code) {
      return !((isNaN(code)) || (code < 1))
    }

    var parseCode = function (code) {
      var codes = code.split('-');
      if (codes.length !== 2) {
        return null;
      } 
      else {
        var codesParsed = {
          class_id: codes[1],
          teacher_id: codes[0]
        };
        if (isValidCode(codesParsed.class_id) && isValidCode(codesParsed.teacher_id)) {
          return codesParsed;
        } 
        else {
          return null;
        }
      }
    }

    var messageHandler = reg.messageHandler = {
      message: null,
      type: 'info',
      display: false,
      timeoutCancel: null,
      ext: '',
      hide: function(){
        messageHandler.display = false;
      },
      show: function(){
        messageHandler.display = true;
      },
      get: function(){
        return language.get(this.message) + this.ext;
      },
      getClass: function(){
        switch(messageHandler.type) {
          case 'success': return {'notification': true, 'is-success': true}
          case 'error':   return {'notification': true, 'is-danger': true}
          default:        return {'notification': true, 'is-info': true}
        }
      },
      set: function(langId, type='info', ext=null) {
        messageHandler.type = ['info','error','success'].indexOf(type) > -1 ? type : 'info';
        messageHandler.message = langId;
        $timeout(function(){
          messageHandler.show()
        }, TIMING_CONSTANTS.SCOPE_REFRESH_DELAY_MS)
        messageHandler.ext = ext ? ext : '';
        if(messageHandler.timeoutCancel){
          $timeout.cancel(messageHandler.timeoutCancel)
        }
        messageHandler.timeoutCancel = $timeout(messageHandler.hide, TIMING_CONSTANTS.MESSAGE_HIDE_DELAY_MS)
      }
    }

    var mticInfo = reg.mticInfo = {
      
      username: '',
      
      userpassword: '',
      
      determineAccountType: function () {
        if (Number(reg.flow.accountType) === IAM_CODES.TEACHER) {
          return LOGIN_CONSTANTS.ACCOUNT_TYPES.TEACHER;
        } 
        else {
          return LOGIN_CONSTANTS.ACCOUNT_TYPES.STUDENT;
        }
      },

      login: function() {

        if(isEmptyString(mticInfo.username) || isEmptyString(mticInfo.userpassword)) {
          messageHandler.set(11306, 'error');
          return;
        }

        messageHandler.set(8147, 'info')
        
        api.nonSystematicLogin(
          mticInfo.username,
          mticInfo.userpassword
        )
        .then( function(res) {
          var roles = res.roles, 
              session_key = res.session_key, 
              user_id = res.user_id;
          var role = userAccount.determineRole(roles);
          var req = {
            session_key: session_key, 
            user_id: user_id
          }
          if(role.role_type === mticInfo.determineAccountType()) {
            return api.linkIam(msfUser, req)
          }
          else{
            throw {message: 'INVALID_ROLE'}
          }
        })
        .then(function() {
          messageHandler.set(8147, 'info')
          return api.login({uuid: mticInfo.username, password: mticInfo.userpassword})
        })
        .catch( function(res) {

          var message = res.message;
          var stack = res.stack;
          $log.info(res)
          
          if(message === 'NOT_FOUND__USER_AUTHS') {
            messageHandler.set(8157, 'error');
          }
          else if(message === 'INVALID_ROLE'){
            messageHandler.set(8154, 'error');
          }

          if(message === 'BAD_PASSWORD') {
            messageHandler.set(11308, 'error');
          }
          else{
            messageHandler.set(8152, 'error');
          }

        });

      }
    }

    reg.iamInfo = {

      classCode: '',

      teacherCode: '',

      validateStudent: function(){

        var parsedCode = parseCode(reg.iamInfo.classCode);

        if(parsedCode !== null) {

          var firstName = reg.info.firstName, 
              lastName = reg.info.lastName, 
              username = reg.info.username, 
              password = reg.info.password, 
              iam = reg.info.iam, 
              iamUser = reg.info.iamUser ;

          var teacher_id = parsedCode.teacher_id, 
              class_id = parsedCode.class_id;

          return api.signUpStudent(
              teacher_id,
              class_id,
              username,
              password,
              firstName,
              lastName
          )
          .then( function(){
            api.nonSystematicLogin(
              username,
              password
            )
          })
          .then( function(res) {
            var session_key = res.session_key;
            var user_id = res.session_key;
            messageHandler.set(8254,'info')
            return api.linkIam(msfUser, {
              session_key: session_key, 
              user_id: user_id
            })
          })
          .then(function() {
            messageHandler.set(8254,'info')
            return api.login({
              uuid: username, 
              password
            });
          })
          .catch( function(res) {
            var message = res.message, 
                stack = res.stack
            // $log.debug(res)
            if(message === 'NOT_FOUND_USER_ROLES') {
              messageHandler.set(8253, 'error')
            }else{
              messageHandler.set(8152, 'error')
            }
          });
        }
        else {
          messageHandler.set(8253, 'error')
        }
      },
      validateTeacher: function(){
        $log.info('validateTeacher!! is WIP')
      }
    }

    reg.$onChanges = function(){
      msfUser = reg.profile;
      msfEmail= msfUser.unique_name;
    }

    reg.$onInit = function() {
      msfUser = reg.profile;
      msfEmail= msfUser.unique_name;
    }

  }
});
